jQuery(document).ready(function(){
jQuery('div#shopify-section-footer-classic-0').append(jQuery('div#shopify-section-702b3b27-e4dc-4ccf-82a5-4ff1cf95fae5'));
});

$(document).ready(function(){

$('div#shopify-section-58f6aae6-adc2-420e-a51b-64598ec235c9').append($('div#shopify-section-702b3b27-e4dc-4ccf-82a5-4ff1cf95fae5'));
$('#shopify-section-702b3b27-e4dc-4ccf-82a5-4ff1cf95fae5 > div.newsletter-form__wrapper > form > div > div.field.is-stretched-width > div').append($('#shopify-section-702b3b27-e4dc-4ccf-82a5-4ff1cf95fae5 > div.newsletter-form__wrapper > form > div > div.field.is-default-width.is-align-self-end > div'));
});


var ur = window.location.href;
if(ur.includes('/pages/black-friday-2023')){
  jQuery(document).ready(function(){
$('a.logo-list__link').click(function(){
  console.log('clicking');
  var hr = $(this).attr('href').replace('#', '.');
  var elementToScrollTo = document.querySelectorAll(hr)[0];

  // Check if the element is found
  if (elementToScrollTo) {
    // Scroll to the element
    elementToScrollTo.scrollIntoView({ behavior: 'smooth' });
  }
}); 
});
}

/*JM added this code to fix issue of Notify Me Option won't show when sorting gets updated 8-29-2024*/
$(document).ready(function(){
  $(".collection__sort-by-filter.select .sort_by, .collection__tag-filter.select .tag_filter").on('change', function() {
    setTimeout(function() { 
      location.reload();
    }, 1500);
  });
});

/*JM added this to auto open the shop menu on mobile 9-19-2024*/
$(document).ready(function(){
var window_size = $( window ).width();
  console.log(window_size);
   if(window_size <= 480) {
     $("label[for='mobile-submenu-1']").click();
   }
});